/**
 =========================================================
 * Material Dashboard 2 React - v2.0.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2021 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CircularProgress from '@mui/material/CircularProgress';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "../../examples/Tables/DataTable";


import PageLayout from "examples/LayoutContainers/PageLayout";

import Footer from "examples/Footer";
import Formulario from "./components/Fomulario"
import {useEffect, useState, useContext} from "react";
import {useParams} from "react-router-dom";

import CandidatoContext from "../../context/candidato/candidatoContext";
import axios from '../../config/axios';


function REC_RES_CARTAO(props) {
    const [imagems, setImagens] = useState([{nome: '', imagem: ''}])
    const [candidato, setCandidato] = useState([{nome: '', cargo: '', extra: []}])
    const [token, setToken] = useState('')
    const {candidatoState, candidatoDispatch} = useContext(CandidatoContext);


    useEffect(() => {
        //Verifica refresh
        if (candidatoState.concurso.edital.length === 0) {
            candidatoDispatch({type: "REFRESH"})
        }
    }, [])

    useEffect(() => {
        (async () => {
            console.log('candidatoState', candidatoState);
            let response = await axios.post('/candidato/resultado_recurso', {
                    token: candidatoState.token
            });

            setCandidato(response.data);
        })()
    }, [candidatoState])

    const loading = () => {
        return imagems[0].nome.length === 0 && (<CircularProgress/>);
    }

    const mostra_justificativa = () => {
        if (candidato.justificativa && candidato.justificativa.length > 0)
            return "JUSTIFICATIVA"
        else
            return ""
    }

    const monta_tabela = () => {
        if (!candidato.extra)
            return;

        let conteudo = [];
        let interno = []
        //Monta as colunas
        let a;

        let items_ordenado = []

        for (let obj of candidato.extra) {
            for (let item in obj) {
                items_ordenado.push(item);
            }
            items_ordenado.sort();
            for(let item of items_ordenado){
                interno.push(<Grid>
                    <MDTypography  mt={3} variant="h5" fontWeight="bold">
                        {item} <br></br>
                    </MDTypography>
                    <MDTypography variant="p">
                        {obj[item]} <br></br>
                    </MDTypography>
                </Grid>)
            }

            conteudo.push(<Grid mt={5} pl={2} border={'2px solid'}>{interno}</Grid>)
            interno=[]
            items_ordenado=[]
        }


        return (
            <MDBox>
                {/*{candidato.extra.map(item=>{return `${JSON.stringify(item)}`})}*/}
                {conteudo}
            </MDBox>
        )
    }
    return (<PageLayout>
        <MDBox pt={10} width="80%" m="auto">
            <Card>
                <MDBox display="flex" justifyContent="center" alignItems="center" p={3}>
                    <Grid container spacing={3} justifyContent='center'>
                        <Grid item xs={12} md={4} xl={2} textAlign="center">
                            <img style={{width: '100%'}}
                                 src={candidatoState.concurso.logo}/>
                        </Grid>
                        <Grid item xs={12} textAlign="center">
                            <MDTypography variant="button" fontWeight="bold">
                                {candidatoState.concurso.edital}
                                <br></br>
                                {candidatoState.concurso.nome}
                            </MDTypography>
                        </Grid>

                        <Grid item xs={12} textAlign="center">
                            <MDTypography variant="h4" fontWeight="bold" style={{color: "#184282"}} color="text">

                            </MDTypography>
                        </Grid>

                        <Grid item xs={12} textAlign="center">
                            <MDTypography variant="h4" fontWeight="bold" color="text">
                                {candidato.titulo}
                            </MDTypography>
                        </Grid>

                        <Grid item xs={12} textAlign="center">
                            <MDTypography variant="h6" fontWeight="bold" color="text">
                                {candidato.cargo}
                            </MDTypography>
                            <br></br>
                            <MDTypography variant="h5" fontWeight="bold" color="text">
                                {candidato.nome}
                            </MDTypography>

                        </Grid>
                        <Grid item xs={12} textAlign="center">
                            <MDTypography variant="h6" fontWeight="bold" color="text">
                                {/*{candidato.cargo}*/}
                            </MDTypography>
                        </Grid>



                        <Grid item xs={8}>
                            {monta_tabela()}
                        </Grid>

                    </Grid>
                </MDBox>

            </Card>
            <Footer/>
        </MDBox>
    </PageLayout>);
}

export default REC_RES_CARTAO;
